module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "intro"
    }
  }, [(!_vm.device) ? _c('div', {
    attrs: {
      "id": "pcIntro"
    }
  }, [_c('div', {
    staticClass: "scalePart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "KV"
  }, [_c('div', {
    staticClass: "character lion"
  }), _vm._v(" "), _c('div', {
    staticClass: "couplets"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.goPCLInk()
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "character bride"
  }), _vm._v(" "), _c('div', {
    staticClass: "character fatBoy"
  }), _vm._v(" "), _c('div', {
    staticClass: "character oldWoman"
  }), _vm._v(" "), _c('div', {
    staticClass: "character officeLady"
  }), _vm._v(" "), _c('div', {
    staticClass: "character dog"
  }), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "linkSection"
  }, [_c('a', {
    staticClass: "logoSobo",
    attrs: {
      "target": "_blank",
      "href": "http://www.sobo.com.tw/design/"
    },
    on: {
      "click": _vm.openSobo
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/link-sobo.png",
      "alt": "SOBO 淞泊創意設計"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "logoWeddings",
    attrs: {
      "target": "_blank",
      "href": "http://www.weddings.tw/"
    },
    on: {
      "click": _vm.openWedding
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/link-weddings.png",
      "alt": "Weddings 新娘物語"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.device) ? _c('div', {
    attrs: {
      "id": "moIntro"
    }
  }, [_c('div', {
    staticClass: "KV"
  }, [_c('div', {
    staticClass: "character lion"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "character bride"
  }), _vm._v(" "), _c('div', {
    staticClass: "character fatBoy"
  }), _vm._v(" "), _c('div', {
    staticClass: "character oldWoman"
  }), _vm._v(" "), _c('div', {
    staticClass: "character officeLady"
  }), _vm._v(" "), _c('div', {
    staticClass: "character dog"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.goMOLInk()
      }
    }
  }, [_vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "linkSection"
  }, [_c('a', {
    staticClass: "logoSobo",
    attrs: {
      "href": "http://www.sobo.com.tw/design/"
    },
    on: {
      "click": _vm.openSobo
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/link-sobo.png",
      "alt": "SOBO 淞泊創意設計"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "logoWeddings",
    attrs: {
      "href": "http://www.weddings.tw/"
    },
    on: {
      "click": _vm.openWedding
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/link-weddings.png",
      "alt": "Weddings 新娘物語"
    }
  })])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lanternGroup"
  }, [_c('div', {
    staticClass: "lantern"
  }), _vm._v(" "), _c('div', {
    staticClass: "lantern"
  }), _vm._v(" "), _c('div', {
    staticClass: "lantern"
  }), _vm._v(" "), _c('div', {
    staticClass: "lantern"
  }), _vm._v(" "), _c('div', {
    staticClass: "lantern"
  }), _vm._v(" "), _c('div', {
    staticClass: "lantern"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('img', {
    attrs: {
      "src": "/static/img/title-couplets.png",
      "alt": "2018 新年發大財"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "center"
  }, [_vm._v("搶發財金"), _c('span', {
    staticClass: "arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "character tsaiShen"
  }, [_c('div', {
    staticClass: "treasureGroup"
  }, [_c('div', {
    staticClass: "treasure coin coin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_4"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_5"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_6"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_7"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_8"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_9"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure redPacket redPacket_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure redPacket redPacket_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure redPacket redPacket_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure redPacket redPacket_4"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure ingots ingots_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure ingots ingots_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure ingots ingots_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure ingots ingots_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couplets"
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": "/static/img/mobile/title-couplets.png",
      "width": "137",
      "height": "104",
      "alt": "2018 新年發大財"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "character tsaiShen"
  }, [_c('div', {
    staticClass: "treasureGroup"
  }, [_c('div', {
    staticClass: "treasure coin coin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_4"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_5"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_6"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_7"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_8"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure coin coin_9"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure redPacket redPacket_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure redPacket redPacket_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure redPacket redPacket_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure redPacket redPacket_4"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure ingots ingots_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure ingots ingots_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure ingots ingots_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "treasure ingots ingots_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "center"
  }, [_vm._v("搶發財金"), _c('span', {
    staticClass: "arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5387bdbd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 450
// module chunks = 0